/**
 * MYNEEED Cart Drawer — AJAX Cart Management
 * v1.0 — HAYTEK
 */
(function () {
  'use strict';

  /* ── DOM refs ── */
  var drawer, overlay, itemsEl, subtotalEl;

  /* ── Init ── */
  function init() {
    drawer    = document.getElementById('mn-cart-drawer');
    overlay   = document.getElementById('mn-cart-overlay');
    itemsEl   = document.getElementById('mn-cart-items');
    subtotalEl= document.getElementById('mn-cart-subtotal');

    // Fetch count on load
    fetchCart(function (cart) { updateBadge(cart.item_count); });

    // Cart-icon triggers
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-open]');
      if (trigger) { e.preventDefault(); openDrawer(); }

      var close = e.target.closest('[data-cart-close]');
      if (close) closeDrawer();
    });

    // Overlay click
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Intercept ATC forms with data-mn-atc (capture:true runs before global.js)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.hasAttribute('data-mn-atc')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      ajaxATC(form);
    }, true);
  }

  /* ── API helpers ── */
  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function (err) { console.warn('[mn-cart] fetch error', err); });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  /* ── Open / Close ── */
  function openDrawer() {
    fetchCart(function (cart) {
      renderCart(cart);
      if (drawer)  { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
      if (overlay) overlay.classList.add('is-active');
      document.body.classList.add('mn-drawer-open');
      loadUpsell();
    });
  }

  function closeDrawer() {
    if (drawer)  { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
    if (overlay) overlay.classList.remove('is-active');
    document.body.classList.remove('mn-drawer-open');
  }

  /* ── Badge ── */
  function updateBadge(count) {
    document.querySelectorAll('.mn-cart-badge').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : count;
      el.hidden = count === 0;
    });
  }

  /* ── Render cart ── */
  function renderCart(cart) {
    updateBadge(cart.item_count);

    // Subtotal
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Items
    if (!itemsEl) return;
    if (cart.items.length === 0) {
      itemsEl.innerHTML =
        '<div class="mn-ci-empty">' +
          '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
          '<p>Dein Warenkorb ist leer</p>' +
          '<a href="/collections/all" class="mn-ci-empty__cta" onclick="event.stopPropagation();mnCartClose()">Jetzt shoppen →</a>' +
        '</div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.featured_image
        ? item.featured_image.url.replace(/(\.\w+)(\?|$)/, '_120x120$1$2')
        : '';
      html +=
        '<div class="mn-ci" data-key="' + item.key + '">' +
          (imgSrc ? '<img class="mn-ci__img" src="' + imgSrc + '" alt="' + escHtml(item.product_title) + '" loading="lazy">' : '<div class="mn-ci__img mn-ci__img--placeholder"></div>') +
          '<div class="mn-ci__body">' +
            '<div class="mn-ci__title">' + escHtml(item.product_title) + '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="mn-ci__variant">' + escHtml(item.variant_title) + '</div>' : '') +
            '<div class="mn-ci__row">' +
              '<div class="mn-ci__qty-wrap">' +
                '<button class="mn-ci__qbtn" onclick="mnCartQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Weniger">−</button>' +
                '<span class="mn-ci__qval">' + item.quantity + '</span>' +
                '<button class="mn-ci__qbtn" onclick="mnCartQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Mehr">+</button>' +
              '</div>' +
              '<div class="mn-ci__price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>' +
          '<button class="mn-ci__del" onclick="mnCartQty(\'' + item.key + '\',0)" aria-label="Entfernen">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
          '</button>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
  }

  /* ── AJAX ATC ── */
  function ajaxATC(form) {
    var btn = form.querySelector('[type=submit]');
    var origText = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span style="opacity:.5">…</span>'; }

    var body = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: body })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = origText; }
        openDrawer();
      })
      .catch(function (err) {
        console.warn('[mn-cart] ATC error', err);
        if (btn) { btn.disabled = false; btn.innerHTML = origText; }
      });
  }

  /* ── Upsell via Shopify Recommendations API ── */
  function loadUpsell() {
    var upsellEl = document.getElementById('mn-cart-upsell-products');
    if (!upsellEl) return;
    // Use current product id if on product page
    var productId = document.querySelector('[data-product-id]');
    if (!productId) return;
    var pid = productId.dataset.productId;
    if (!pid) return;

    fetch('/recommendations/products.json?product_id=' + pid + '&limit=2&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || data.products.length === 0) {
          upsellEl.closest('.mn-cart-upsell') && (upsellEl.closest('.mn-cart-upsell').hidden = true);
          return;
        }
        var html = '';
        data.products.forEach(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_120x120$1$2') : '';
          var price = formatMoney(p.variants[0].price);
          html +=
            '<div class="mn-upsell-item">' +
              (img ? '<img class="mn-upsell-item__img" src="' + img + '" alt="' + escHtml(p.title) + '">' : '') +
              '<div class="mn-upsell-item__info">' +
                '<div class="mn-upsell-item__title">' + escHtml(p.title) + '</div>' +
                '<div class="mn-upsell-item__price">' + price + '</div>' +
              '</div>' +
              '<button class="mn-upsell-item__add" ' +
                'onclick="mnCartAddId(' + p.variants[0].id + ', this)" ' +
                'aria-label="In den Warenkorb">+</button>' +
            '</div>';
        });
        upsellEl.innerHTML = html;
        upsellEl.closest('.mn-cart-upsell') && (upsellEl.closest('.mn-cart-upsell').hidden = false);
      })
      .catch(function () {});
  }

  /* ── Helpers ── */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Global API ── */
  window.mnCartOpen  = openDrawer;
  window.mnCartClose = closeDrawer;

  window.mnCartQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (err) { console.warn('[mn-cart] qty error', err); });
  };

  window.mnCartAddId = function (variantId, btn) {
    if (btn) { btn.disabled = true; btn.textContent = '✓'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        fetchCart(renderCart);
        if (btn) {
          btn.textContent = '✓';
          setTimeout(function () { btn.disabled = false; btn.textContent = '+'; }, 1500);
        }
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = '+'; } });
  };

  /* ── B2B Detection (Sami Wholesale) ── */
  function isB2BCustomer() {
    try {
      var samiCustomer = window.Samita &&
                         window.Samita.Wholesale &&
                         window.Samita.Wholesale.shop &&
                         window.Samita.Wholesale.shop.customer;
      // B2B = logged-in customer AND Sami cart drawer is enabled for them
      if (samiCustomer && samiCustomer.id) {
        var cartDrawer = window.Samita.Wholesale.shop.settings &&
                         window.Samita.Wholesale.shop.settings.cart_drawer;
        return cartDrawer && cartDrawer.enable === true;
      }
    } catch (e) {}
    return false;
  }

  /* ── Fetch Interceptor (catches Sami + global.js ATC calls) ── */
  function installFetchInterceptor() {
    var _fetch = window.fetch;
    window.fetch = function(url, opts) {
      var promise = _fetch.apply(this, arguments);
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        // B2B customers → Sami handles their cart drawer
        if (!isB2BCustomer()) {
          promise.then(function(response) {
            if (response.ok) {
              // Small delay so cart state is updated before rendering
              setTimeout(openDrawer, 200);
            }
            return response;
          }).catch(function() {});
        }
      }
      return promise;
    };
  }

  /* ── Start ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  installFetchInterceptor();

})();
